import { styled } from '@mui/system';

export const Footer = styled('div')({
  width: '100%',
  textAlign: "right",
  marginTop: '6vh',
});
